import { useMemo } from 'react'
import { useMencionables, aHandle, variantes } from './useMencionables'

// A comment's text with the @handles that name someone highlighted (hover shows the full name).
// `oscuro`: on a dark bubble. Anything else is shown exactly as written.
const TOKEN = /(?<![\w@.])@([A-Za-z0-9_.\-À-ɏ]+)/gu

export default function TextoConMenciones({ texto, oscuro = false, className = '' }) {
  const gente = useMencionables()
  const indice = useMemo(() => {
    const m = new Map()
    gente.forEach(u => variantes(u).forEach(v => m.set(v, [...(m.get(v) || []), u])))
    return m
  }, [gente])

  const partes = []
  let ultimo = 0
  const s = String(texto || '')
  for (const m of s.matchAll(TOKEN)) {
    const quien = indice.get(aHandle(m[1]))
    if (!quien || quien.length !== 1) continue            // unknown, or two people could be meant: plain text
    if (m.index > ultimo) partes.push(s.slice(ultimo, m.index))
    partes.push(
      <span key={m.index} title={quien[0].nombre}
        className={`rounded px-1 font-medium ${oscuro ? 'bg-white/25 text-white' : 'bg-indigo-50 text-indigo-700'}`}>{m[0]}</span>)
    ultimo = m.index + m[0].length
  }
  if (ultimo < s.length) partes.push(s.slice(ultimo))
  return <span className={className}>{partes}</span>
}
